import React, { useContext, useState } from 'react';

import TicketContext from '@totem/components/ticketing/details/ticketContext';
import NaActivityEditModal from '@totem/components/unauthenticated/ticketing/details/naActivityEditModal';
import NaActivityTable from '@totem/components/unauthenticated/ticketing/details/naActivityTable';

import '../../../ticketing/ticketing.css';

const NaActivities = () => {
  const { ticket } = useContext(TicketContext);
  const [showActivityModal] = useState<boolean>(false);

  return (
    ticket !== null &&
    ticket.ticket !== null &&
    ticket.ticket.activity !== null && (
      <>
        <NaActivityTable ticket={ticket} />
        {showActivityModal && <NaActivityEditModal />}
      </>
    )
  );
};

export default NaActivities;
